export default __webpack_public_path__ + "static/media/red_rec_pressed.b0e3b33e.png";